var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGuidanceTool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "413488f287"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.203125 5.203125 L 369.796875 5.203125 L 369.796875 369.796875 L 5.203125 369.796875 Z M 5.203125 5.203125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7ae755ef4f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 187.5 5.203125 C 86.820312 5.203125 5.203125 86.820312 5.203125 187.5 C 5.203125 288.179688 86.820312 369.796875 187.5 369.796875 C 288.179688 369.796875 369.796875 288.179688 369.796875 187.5 C 369.796875 86.820312 288.179688 5.203125 187.5 5.203125 Z M 187.5 5.203125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b6724f9953"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.203125 0.203125 L 364.796875 0.203125 L 364.796875 364.796875 L 0.203125 364.796875 Z M 0.203125 0.203125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2e5f68edc4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 182.5 0.203125 C 81.820312 0.203125 0.203125 81.820312 0.203125 182.5 C 0.203125 283.179688 81.820312 364.796875 182.5 364.796875 C 283.179688 364.796875 364.796875 283.179688 364.796875 182.5 C 364.796875 81.820312 283.179688 0.203125 182.5 0.203125 Z M 182.5 0.203125 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cb1d79a3ed"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 365,
    y: 0,
    height: 365
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "8cb828488c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 91.453125 96.933594 L 283.453125 96.933594 L 283.453125 303.183594 L 91.453125 303.183594 Z M 91.453125 96.933594 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#413488f287)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7ae755ef4f)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 5, 5)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cb1d79a3ed)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b6724f9953)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2e5f68edc4)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M 0.203125 0.203125 L 364.796875 0.203125 L 364.796875 364.796875 L 0.203125 364.796875 Z M 0.203125 0.203125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#8cb828488c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1f1f22",
    d: "M 91.425781 96.96875 L 92.566406 124.921875 L 165.921875 199.917969 L 165.921875 274.867188 L 208.359375 303.152344 L 208.359375 199.957031 L 283.539062 124.777344 L 282.421875 96.96875 Z M 102.492188 107.578125 L 272.226562 107.578125 L 272.765625 120.550781 L 197.75 195.566406 L 197.75 283.34375 L 176.53125 269.191406 L 176.53125 195.605469 L 103.011719 120.40625 Z M 102.492188 107.578125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuidanceTool);
export default __webpack_public_path__ + "static/media/GuidanceTool.797f1292846cbf493ea8cf887b4858ae.svg";
export { ForwardRef as ReactComponent };